import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import UploadFile from './pages/UploadFile';
import ProtectedRoute from './components/ProtectedRoute';
import Reports from "./pages/Reports";
import DashboardHome from './pages/DashboardHome';
import Settings from "./pages/Settings";
import Register from "./pages/Register";
import ScheduledEmails from "./pages/ScheduleEmails";
import ManageStaff from "./pages/ManageStaff";
import UsageStats from "./pages/UsageStats";
import ActivityLogs from "./pages/ActivityLogs";
import Subscription from "./pages/Subscription";
import SupportTickets from "./pages/SupportTickets";
import { BrandProvider } from './context/BrandContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';


function App() {
  return (
    <BrandProvider>
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
         <Route path="/dashboard" element={
                                            <ProtectedRoute>
                                              <Dashboard />
                                            </ProtectedRoute>
                                          }>
         <Route index element={<DashboardHome />} />
         <Route path="upload" element={<UploadFile />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} />
          <Route path="schedule-emails" element={<ScheduledEmails />} />
          <Route path="manage-staff" element={
            <ProtectedRoute roles={['master_admin']}>
              <ManageStaff />
            </ProtectedRoute>
          } />
          <Route path="create-staff" element={
            <ProtectedRoute roles={['master_admin']}>
              <ManageStaff />
            </ProtectedRoute>
          } />
          <Route path="usage" element={
            <ProtectedRoute roles={['master_admin']}>
              <UsageStats />
            </ProtectedRoute>
          } />
          <Route path="activity" element={
            <ProtectedRoute roles={['master_admin']}>
              <ActivityLogs />
            </ProtectedRoute>
          } />
          <Route path="subscription" element={
            <ProtectedRoute roles={['master_admin']}>
              <Subscription />
            </ProtectedRoute>
          } />
          <Route path="support" element={
            <ProtectedRoute roles={['master_admin']}>
              <SupportTickets />
            </ProtectedRoute>
          } />
          <Route path="support/:id" element={
            <ProtectedRoute roles={['master_admin']}>
              <SupportTickets />
            </ProtectedRoute>
          } />
        </Route>
      </Routes>
    </Router>
    </BrandProvider>
  );
}

export default App;
